import { styled } from '@mui/material';
import React from 'react';
import { padNames } from '../../intl';
export function DrumName({ cx, cy, r, note, position, name }) {
    const { x, y } = nameAnchor(cx, cy, r, position);
    const text = name ?? (note != null ? padNames.get(note) : null);
    if (text == null) {
        return null;
    }
    const box = nameBox(x, y, position, 60, 40);
    return React.createElement(DrumNameBox, { ...box, anchor: position },
        React.createElement("div", { "data-xmlns": "http://www.w3.org/1999/xhtml" },
            React.createElement("div", { className: "drumName" }, text)));
}
function nameAnchor(cx, cy, r, position) {
    switch (position) {
        case 'left':
            return { x: cx - r - 20, y: cy };
        case 'right':
            return { x: cx + r + 20, y: cy };
        case 'top':
            return { x: cx, y: cy - r - 20 };
        case 'bottom':
            return { x: cx, y: cy + r + 20 };
        case 'topleft':
            return { x: cx - r - 20, y: cy - r - 20 };
        case 'topright':
            return { x: cx + r + 20, y: cy - r - 20 };
        case 'bottomleft':
            return { x: cx - r - 20, y: cy + r + 20 };
        case 'bottomright':
            return { x: cx + r + 20, y: cy + r + 20 };
        case 'center':
            return { x: cx, y: cy };
        default:
            throw new Error(`Unknown anchor ${position}`);
    }
}
function nameBox(x, y, position, width, height) {
    switch (position) {
        case 'left':
            return { x: x - width, y: y - height / 2, width, height };
        case 'right':
            return { x: x, y: y - height / 2, width, height };
        case 'top':
            return { x: x - width / 2, y: y - height, width, height };
        case 'bottom':
            return { x: x - width / 2, y: y, width, height };
        case 'topleft':
            return { x: x - width, y: y - height, width, height };
        case 'topright':
            return { x: x, y: y - height, width, height };
        case 'bottomleft':
            return { x: x - width, y: y, width, height };
        case 'bottomright':
            return { x: x, y: y, width, height };
        case 'center':
            return { x: x - width / 2, y: y - height / 2, width, height };
        default:
            throw new Error(`Unknown anchor ${position}`);
    }
}
const DrumNameBox = styled('foreignObject')(({ theme, anchor }) => ({
    '& > div': {
        display: 'flex',
        alignItems: 'center',
        flexDirection: ['top', 'bottom'].includes(anchor) ? 'column' : 'row',
        textAlign: ['left', 'topleft', 'bottomleft'].includes(anchor) ? 'right'
            : ['right', 'topright', 'bottomright'].includes(anchor) ? 'left' : 'center',
        width: '100%',
        height: '100%',
        justifyContent: ['top', 'left'].includes(anchor) ? 'flex-end' : 'flex-start',
    }
}));
//# sourceMappingURL=DrumName.js.map